import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/api/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { BtrBookingService } from './core/services/btr-booking.service';
import { LogService } from './core/log.service';
import { UiService } from './core/ui.service';
import { MessageService } from 'primeng/api';
import { IAppConfig } from './core/config/app-config.model';
import { APP_CONFIG } from './core/config/app-config.service';
import { HotelBookingResStatusType } from './core/api/api.models';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'rbe';
  destroyed = new Subject();
  
  constructor(
    private router: Router,
    private translate: TranslateService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private btrBookingService: BtrBookingService,
    private log: LogService,
    private messageService: MessageService,
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ){
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void {
    this.initUtms();

    if(this.config.themeDefault){
      const body = document.querySelector('body');
      if(body){
        body.classList.add(this.config.themeDefault.toLowerCase());
      }
    }

    if(!this.auth.isLoggedIn() && window.location.href.indexOf('auth0/callback') === -1){
      this.log.log(`captureIDPAuth start`);
      this.auth.captureIDPAuth().subscribe({
        next: (status) => {
          if(!status) this.captureLoginFailed();
          this.log.log(`captureIDPAuth: ${status}`);
            this.route.queryParams.pipe(takeUntil(this.destroyed)).subscribe((params: any) => {
              this.handleQueryParamsChanged(params);
            });
        }
      });
    }

    this.auth.monitor();
  }

  captureLoginFailed() {
    const errorStatus = this.getParameterByName('error'),
      errorMessage = this.getParameterByName('error_description')

    if (errorStatus && errorMessage) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage, key: 'toast', life: 10000 });
      setTimeout(() => {
        this.auth.logout();
      }, 5000)
    }
  }

  handleQueryParamsChanged(params: any){
    if(!params) return;

    if(params.supportSignUp === 'true' && params.success === 'true'){
      this.log.log(`Message: ${params.message}`);

      if(!this.auth.isLoggedIn()){
        this.auth.loginWithIDP(window.location.href);
      }
      else{
        this.log.log(`Continue application process`);
        this.getActiveApplication();
      }
    }

    if(params.error) {
      console.log(params.error)
    }
  }

  ngOnDestroy(): void {
    
  }

  getActiveApplication(){
    this.btrBookingService.getInProgressApplications().subscribe({
      next: (res) => {
        const approveBookingStatus = [
          HotelBookingResStatusType[HotelBookingResStatusType.OptionalWithReductionToInventory],
          HotelBookingResStatusType[HotelBookingResStatusType.OptionalWithoutReductionToInventory],
          HotelBookingResStatusType[HotelBookingResStatusType.Confirmed],
        ]
        if(res.success && res.applicationID && res.redirectCode && approveBookingStatus.includes(res.resStatusType)){
          this.btrBookingService.redirectApplicationDetail(res.applicationID, res.redirectCode);
        } else {
          const selectSiteTour = this.btrBookingService.getSelectedSiteTourInfo();
          if(selectSiteTour && selectSiteTour.returnUrl){
            window.location.href = selectSiteTour.returnUrl
          }
        }
      }
    })
  }

  getParameterByName(name: string) {
    name = name.replace(/[\[]/, "\[").replace(/[\]]/, "\]");
    var regex = new RegExp("[\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  setCookie(name: string, value: string, path: string = '/') {
    document.cookie = name + '=' + (value || '') + '; path=' + path;
  }

  getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setUtm(utm_param: string, utm_val: string) {
    const inputElement = document.querySelector(`input[name="utm_${utm_param}"]`) as HTMLInputElement;
    if (this.getCookie(utm_param + 'y') != undefined) {
      if (inputElement) {
        inputElement.value = '';
        inputElement.value = this.getCookie(`${utm_param}y`) || '';
      }
    } else {
      if(utm_val !== ''){
        this.setCookie(utm_param + 'y', utm_val, '/');
      }
      if (inputElement) {
        inputElement.value = utm_val || '';
      }
    };
  }

  initUtms() {
    let source = this.getParameterByName('utm_source');
    let medium = this.getParameterByName('utm_medium');
    let campaign = this.getParameterByName('utm_campaign');
    let content = this.getParameterByName('utm_content');
    let term = this.getParameterByName('utm_term');

    this.setUtm('source', source);
    this.setUtm('medium', medium);
    this.setUtm('campaign', campaign);
    this.setUtm('content', content);
    this.setUtm('term', term);
  }

}
